import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import useApiConfiguration from "../../apiConfig";
import { CopiaLavoroMassivoRequestDTO, LavoriApi } from "../../data";
import { Button, Calendar, Form } from "devextreme-react";
import { FormRef, Item } from "devextreme-react/form";
import { Popup, Position, ToolbarItem } from "devextreme-react/popup";
import { ClickEvent } from "devextreme/ui/button";
import { LoadPanel } from "devextreme-react";
import { useScreenSize } from "../../utils/media-query";

export type PopupCopiaLavoroHandle = {
    show: (idLavoro: number) => void;
};

type Props = {
    onChange: () => void
};

type State = {
    idLavoro: number,
    visible: boolean
};

const PopupCopiaLavoro: React.ForwardRefRenderFunction<PopupCopiaLavoroHandle, Props> = (props, ref) => {
    const emptyData: CopiaLavoroMassivoRequestDTO = {
        dateDestinazione: [],
        idLavoro: undefined
    };

    const apiConfiguration = useApiConfiguration();
    const formRef = useRef<FormRef>(null);

    const [loading, setLoading] = useState(false);
    const [state, setState] = useState<State>({ idLavoro: 0, visible: false });
    const [formData, setFormData] = useState<CopiaLavoroMassivoRequestDTO>();
    const { isSmall, isXSmall } = useScreenSize();

    useImperativeHandle(ref, () => ({
        show(idLavoro) {
            setState({ idLavoro: idLavoro, visible: true });
        }
    }));

    useEffect(() => {
        if (state.visible && state.idLavoro) {
            setFormData({
                ...emptyData,
                idLavoro: state.idLavoro
            });
        }
    }, [state.idLavoro, state.visible]);

    const copiaLavoro = (e: ClickEvent) => {
        const validate = formRef.current?.instance().validate();

        if (validate?.isValid) {
            setLoading(true);

            var api = new LavoriApi(apiConfiguration);
            api.copiaLavoroMassivo({
                copiaLavoroMassivoRequestDTO: formData
            })
                .then(() => props.onChange())
                .finally(() => {
                    setLoading(false);
                    hideInfo();
                });
        }
    };

    function hideInfo() {
        setState({ idLavoro: 0, visible: false });
    }

    return (
        <React.Fragment>
            <Popup
                visible={state.visible} dragEnabled={false} hideOnOutsideClick
                showCloseButton showTitle title="Copia lavoro" fullScreen={(isSmall || isXSmall)}
                width={500} height={450} container=".dx-viewport" onHidden={hideInfo}
            >
                {loading && <LoadPanel style={{ zIndex: 9999 }} visible shading shadingColor="rgba(0, 0, 0, 0.4)" position={'center'} />}

                <Position at="center" my="center" of="" collision="fit" />

                <ToolbarItem widget="dxButton" toolbar="bottom" location="center">
                    <Button
                        onClick={copiaLavoro}
                        icon="copy"
                        text="Copia"
                        type="default"
                        stylingMode="contained"
                    />
                </ToolbarItem>

                <Form ref={formRef} labelMode="floating" formData={formData}>
                    <Item visible={false} dataField="idLavoro" />

                    <Item dataField="dateDestinazione" isRequired={true} label={{ text: "Data copia" }}
                        render={() => (
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <Calendar
                                    value={formData?.dateDestinazione}
                                    selectionMode="multiple" firstDayOfWeek={1}
                                    focusStateEnabled={true}
                                    onValueChanged={(e) =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            dateDestinazione: e.value
                                        }))
                                    }
                                />
                            </div>
                        )}
                    />
                </Form>
            </Popup>
        </React.Fragment>
    )
}

export default React.forwardRef(PopupCopiaLavoro);